import { TableCell, TableHead as MuiTableHead, TableRow } from "@mui/material";
import type { HeaderGroup, RowData } from "@tanstack/react-table";
import { flexRender } from "@tanstack/react-table";

import { ACTION_COLUMN_ID, ROW_NUMBER_COLUMN_ID } from "./constants";

interface Props<TData extends RowData> {
    headerGroups: HeaderGroup<TData>[];
}

const commonHeaderCellStyle = {
    fontWeight: "bold",
    textAlign: "center",
    backgroundColor: "#F6F6F6",
    borderBottom: "1px solid #e0e0e0",
    borderRight: "1px solid #e0e0e0",
    "&:last-child": {
        borderRight: 0,
    },
    height: "50px",
    verticalAlign: "middle",
};

export const getColumnLetter = (index: number): string => {
    let columnName = "";
    let current = index;
    while (current >= 0) {
        columnName = String.fromCharCode((current % 26) + 65) + columnName;
        current = Math.floor(current / 26) - 1;
    }
    return columnName;
};

export default function TableHead<TData extends RowData>({ headerGroups }: Props<TData>) {
    return (
        <MuiTableHead>
            {headerGroups.length > 0 && (
                <TableRow key="letter-row">
                    {headerGroups[0].headers.map((header, index) => (
                        <TableCell
                            component="td"
                            key={`letter-${header.id}`}
                            sx={{
                                ...commonHeaderCellStyle,
                                width: header.getSize(),
                            }}
                        >
                            {header.id === ACTION_COLUMN_ID
                                ? ""
                                : header.id === ROW_NUMBER_COLUMN_ID
                                  ? ""
                                  : getColumnLetter(index - 2)}
                        </TableCell>
                    ))}
                </TableRow>
            )}

            {headerGroups.map((headerGroup) => (
                <TableRow key={headerGroup.id}>
                    {headerGroup.headers.map((header) => {
                        return (
                            <TableCell
                                key={header.id}
                                colSpan={header.colSpan}
                                sx={{
                                    ...commonHeaderCellStyle,
                                    width: header.getSize(),
                                }}
                            >
                                {header.id === ROW_NUMBER_COLUMN_ID
                                    ? null
                                    : header.isPlaceholder
                                      ? null
                                      : flexRender(header.column.columnDef.header, header.getContext())}
                            </TableCell>
                        );
                    })}
                </TableRow>
            ))}
        </MuiTableHead>
    );
}
